module.exports = __webpack_public_path__ + "OpenSans-BoldItalic-5aaceea2d60ddb477c6aafc825eece3d.woff2";